import { redirect } from "@tanstack/react-router"
import type { SessionInfo } from "@/api/generated/SessionInfo"
import { type Capability, can } from "@/lib/permissions"

/**
 * `beforeLoad` guard for a route subtree: users without the capability are
 * sent to their home page (which they can always access).
 *
 * ```ts
 * export const Route = createFileRoute("/_app/studio")({ beforeLoad: requireCap("management") })
 * ```
 */
export function requireCap(cap: Capability) {
  return ({ context }: { context: { session: SessionInfo } }) => {
    if (!can(context.session, cap)) throw redirect({ to: "/", replace: true })
  }
}
